import React from "react";

export const H1: React.FC<React.PropsWithChildren> = ({ children }) => (
  <h1 style={{ fontSize: '2rem', margin: '0 0 .25rem' }}>{children}</h1>
);
export const H2: React.FC<React.PropsWithChildren> = ({ children }) => (
  <h2 style={{ fontSize: '1.5rem', margin: '.5rem 0 .25rem' }}>{children}</h2>
);
export const H3: React.FC<React.PropsWithChildren> = ({ children }) => (
  <h3 style={{ fontSize: '1.25rem', margin: '1rem 0 .25rem' }}>{children}</h3>
);
export const P: React.FC<React.PropsWithChildren> = ({ children }) => (
  <p style={{ margin: '.5rem 0' }}>{children}</p>
);
export const Ol: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ol style={{ margin: '.5rem 0 .5rem 1.25rem' }}>{children}</ol>
);
export const Line = () => <hr style={{ border: 0, borderTop: '1px solid #000', margin: '.5rem 0 1rem' }} />;
export const DoubleLine = () => <hr style={{ border: 0, borderTop: '3px double #000', margin: '.75rem 0 1.25rem' }} />;
export const HangingP: React.FC<React.PropsWithChildren> = ({ children }) => (
  <p style={{ textIndent: '-1.5em', marginLeft: '1.5em', margin: '.5rem 0' }}>{children}</p>
);
export const Indent: React.FC<React.PropsWithChildren> = ({ children }) => (
  <blockquote style={{ margin: '.5rem 0 .5rem 1.5em' }}>{children}</blockquote>
);
export const Subheader: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div style={{ fontSize: '1.25rem', fontWeight: 700, margin: '1rem 0 .25rem' }}>{children}</div>
);